var _rect, _circle, _circle2, _line, _circle3, _line2, _circle4, _line3, _circle5, _line4, _circle6, _line5, _line6, _line7, _line8, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fef2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 45,
    fill: "#fecaca",
    opacity: 0.35,
    stroke: "#ef4444",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 25,
    fill: "#fecaca",
    opacity: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 82,
    x2: 200,
    y2: 65,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 62,
    r: 5,
    fill: "#ef4444",
    opacity: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 178,
    x2: 200,
    y2: 195,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 198,
    r: 5,
    fill: "#ef4444",
    opacity: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 130,
    x2: 135,
    y2: 130,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 130,
    r: 5,
    fill: "#ef4444",
    opacity: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 130,
    x2: 265,
    y2: 130,
    stroke: "#ef4444",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.45
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 130,
    r: 5,
    fill: "#ef4444",
    opacity: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 96,
    x2: 155,
    y2: 85,
    stroke: "#ef4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.35
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 234,
    y1: 96,
    x2: 245,
    y2: 85,
    stroke: "#ef4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.35
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 164,
    x2: 155,
    y2: 175,
    stroke: "#ef4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.35
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 234,
    y1: 164,
    x2: 245,
    y2: 175,
    stroke: "#ef4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.35
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 252,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#991b1b"
  }, "Covid-19 PCR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.cd094b6970e8e451b85b341c863d7901.svg";
export { ForwardRef as ReactComponent };